export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11756.c5f6036a.jpg";